export const getNumberValue = (val) => {
  if (typeof val === 'number' || typeof val === 'string') {
    return Number(val).toLocaleString('en-US');
  }
  if (Array.isArray(val)) {
    return Number(val.length).toLocaleString('en-US');
  }
  return null;
}
